import Modal from '../../scripts/modal'
import SiteMessages from "../../components/site-messages";

class DeleteAccount {
  constructor(button) {

    this.button = button;
    this.button.addEventListener('click', this.openModal.bind(this));

  }

  openModal() {

    this.button.disabled = true;

    this.modal = new Modal({
      title: 'Delete Your Account',
    });

    this.modal.setContent(`
    
    <div class="grid-container">
    
    <p>Are you sure you wish to delete your account?</p>
    
    <div class="grid-x grid-margin-x form-modal__row">
      <div class="cell medium-2">User</div>
      <div class="cell medium-8" style="font-weight: bold; font-size:1.2em;">
        ${window.currentUser.email}
      </div>
    </div>
    
    <p class="delete-account-status">Checking your account...</p>
      
    <div class="form-modal-actions">
      <div class="form-modal-actions__submit">
        <button disabled type="button" class="button" style="margin-right: 20px;" data-for="okay">Delete Account</button>&nbsp;
        <button type="button" class="button gray" data-for="cancel">Cancel</button>
      </div>
    </div>
    
    </div>
      
  `);

    const deleteStatusMessage = this.modal.getContentContainer().querySelector('.delete-account-status');

    const okayButton = this.modal.getContentContainer().querySelector('button[data-for="okay"]');
    const cancelButton = this.modal.getContentContainer().querySelector('button[data-for="cancel"]');

    cancelButton.disabled = false;
    okayButton.disabled = true;

    okayButton.addEventListener('click', () => {

      this.modal.getContentContainer().classList.add('loading-overlay');

      apiRequest('post', '/user/delete-account').then(res => {

        if(res.type === 'success') {

          SiteMessages.addMessage('success', 'Successfully deleted your account');
          logout();

        } else {
          deleteStatusMessage.innerHTML = res.message;
        }

        this.modal.getContentContainer().classList.remove('loading-overlay');
        this.button.disabled = false;

      });

    });

    cancelButton.addEventListener('click', () => {
      this.modal.close();
    });

    this.modal.getContentContainer().classList.add('loading-overlay');
    this.modal.open();

    apiRequest('get', '/user/delete-precheck').then(res => {

      let message = '';

      if(res.type === 'success') {
        switch (res.data.reason) {
          case('has_sub_users'):
            message = "Your account currently has sub users, please remove the sub users first before deleting your account."
            break;
          case('is_demo'):
            message = "This is a demo account and cannot be deleted."
            break;
          case('success'):
            if(window.currentUser.is_sub_user == 1) {
              message = 'This is a sub user account, you can delete your account.  This will not change existing ' +
                'account settings. After deleting your account you will need a new invite to get access again.';
            } else {
              message = 'If you continue you will permanently delete your account and will lose your alerts and sensors. ' +
                'This cannot be undone.';
            }
            break;
        }

        if(res.data.is_allowed == 1) {
          okayButton.disabled = false;
        } else {
          okayButton.disabled = true;
        }

        deleteStatusMessage.innerHTML = message;

      } else {
        deleteStatusMessage.innerHTML = res.message;
      }

      this.modal.getContentContainer().classList.remove('loading-overlay');
      this.button.disabled = false;

    });

  }

}

export default DeleteAccount;
